[
    {
        "list": [
            {
                "title": "Application",
                "href": "admin/application",
                "icon": "menu-app"
            },
            {
                "title": "Model",
                "href": "admin/model",
                "icon": "hdd-fill"
            },
            {
                "title": "BitMap screen",
                "href": "admin/bit-map",
                "icon": "stack"
            }
        ]
    }
]
